<!-- Sidenav slot -->
<cwc-sidenav slot="sidenav">
    <cwc-sidenav-menu design-version="v2" id="menuNav" slot="menu-items">
        <cwc-sidenav-menu-item label="{{ 'Usuarios' | translate }}" icon-name="social-group-regular">
            <cwc-sidenav-menu-item label="{{ 'Todos los usuarios' | translate }}"
                (click)="navigateTo('/admin/customer/list')"></cwc-sidenav-menu-item>



            <cwc-sidenav-menu-item *ngFor="let item of typesProfiles" [label]="item.label"
                (click)="navigateTo('/admin/customer/list/' + item.value)">
            </cwc-sidenav-menu-item>


            <cwc-sidenav-menu-item [attr.label]="'Eliminados' | translate" (click)="navigateTo('/admin/customer/inactive' )">
            </cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item [attr.label]="'Bloqueados' | translate" (click)="navigateTo('/admin/customer/block' )">
            </cwc-sidenav-menu-item>

        </cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Validaciones' | translate }}" icon-name="module-order-product-catalogue">
            <cwc-sidenav-menu-item label="{{ 'Ciudad' | translate }}"
                (click)="navigateTo('/admin/validations/list-city')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Ferreterias' | translate }}"
                (click)="navigateTo('/admin/validations/list-hardware-stores')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Ciudad y Ferreteria' | translate }}"
                (click)="navigateTo('/admin/validations/list-city-hardwarestore')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Acumulacion MP' | translate }}"
                (click)="navigateTo('/admin/validations/list-accumulation-mp')"></cwc-sidenav-menu-item>
        </cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Lista redenciones' | translate }}" icon-name="money-regular"
            (click)="navigateTo('/admin/redemptions/list')"></cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Lista Facturas' | translate }}" icon-name="module-invoices-payments">
            <cwc-sidenav-menu-item label="{{ 'Facturas' | translate }}"
                (click)="navigateTo('/admin/invoices/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Facturas MP' | translate }}"
                (click)="navigateTo('/admin/invoices/list-mp')"></cwc-sidenav-menu-item>
        </cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Lista Referidos' | translate }}" icon-name="split"
            (click)="navigateTo('/admin/referred/list')"></cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Lista Bonos' | translate }}" icon-name="promo"
            (click)="navigateTo('/admin/bonuses/list')"></cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Reportes' | translate }}" icon-name="report">
            <cwc-sidenav-menu-item label="{{ 'Reporte General' | translate }}"
                (click)="navigateTo('/admin/report/general')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Descargas' | translate }}"
                (click)="navigateTo('/admin/settings/')"></cwc-sidenav-menu-item>
        </cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'CRM' | translate }}" icon-name="module-loyalty-program">
            <cwc-sidenav-menu-item label="{{ 'C. Abiertos' | translate }}"
                (click)="navigateTo('/admin/crm/open')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'C. Cerrados' | translate }}"
                (click)="navigateTo('/admin/crm/closed')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'C. Cerrados NV' | translate }}"
                (click)="navigateTo('/admin/crm/closed-nv')"></cwc-sidenav-menu-item>
        </cwc-sidenav-menu-item>
        <cwc-sidenav-menu-item label="{{ 'Configuración' | translate }}" icon-name="settings">
            <cwc-sidenav-menu-item label="{{ 'Configuracion' | translate }}"
                (click)="navigateTo('/admin/settings/configuration/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Administradores' | translate }}"
                (click)="navigateTo('/admin/settings/users/list-user')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Segmentación' | translate }}"
                (click)="navigateTo('/admin/settings/segmentation')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Ferreterias' | translate }}"
                (click)="navigateTo('/admin/settings/hardware-stores/list')"></cwc-sidenav-menu-item>
            <!-- <cwc-sidenav-menu-item label="{{ 'Subida Ferreterias' | translate }}"
                (click)="navigateTo('/admin/settings/hardware-stores/list')"></cwc-sidenav-menu-item> -->
            <cwc-sidenav-menu-item label="{{ 'Referencias' | translate }}"
                (click)="navigateTo('/admin/settings/references/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Regla de Productos' | translate }}"
                (click)="navigateTo('/admin/settings/rules-product/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Regla por facturas' | translate }}"
                (click)="navigateTo('/admin/settings/rules-invoice/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Regla por registro' | translate }}"
                (click)="navigateTo('/admin/settings/rules-register/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Regla cantidad referido' | translate }}"
                (click)="navigateTo('/admin/settings/rules-register-referred/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Regla Bienvenido' | translate }}"
                (click)="navigateTo('/admin/settings/rules-welcome-r/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'CRM' | translate }}">
                <cwc-sidenav-menu-item label="{{ 'Reglas CRM' | translate }}"
                    (click)="navigateTo('/admin/settings/crm/rules-crm/list')"></cwc-sidenav-menu-item>
                <cwc-sidenav-menu-item label="{{ 'Fuentes CRM' | translate }}"
                    (click)="navigateTo('/admin/settings/crm/fuentes-crm/list')"></cwc-sidenav-menu-item>

            </cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Perfiles' | translate }}"
                (click)="navigateTo('/admin/settings/profiles/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Mensajes' | translate }}"
                (click)="navigateTo('/admin/settings/messages/list')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Medios Pago' | translate }}"
                (click)="navigateTo('/admin/settings/payment-types/categories/list-base')"></cwc-sidenav-menu-item>
            <cwc-sidenav-menu-item label="{{ 'Logs auditoria' | translate }}"
                (click)="navigateTo('/admin/settings/logs/list')"></cwc-sidenav-menu-item>
        </cwc-sidenav-menu-item>
    </cwc-sidenav-menu>

    <cwc-footer-menu slot="links">
        <cwc-footer-menu-item label="{{ 'Legal' | translate }}" href="https://www.cemex.com/legal"
            target="_blank"></cwc-footer-menu-item>
        <cwc-footer-menu-item label="{{ 'Privacy' | translate }}"
            onclick="window.alert('Triggered by a javascript function')"></cwc-footer-menu-item>
        <cwc-footer-menu-item label="{{ 'cemex.com' | translate }}" href="https://www.cemex.com"
            target="_blank"></cwc-footer-menu-item>
    </cwc-footer-menu>

    <div slot="copyright">{{ '© 2025 CEMEX' | translate }}<br />
        {{ 'International Holding AG.' | translate }}<br />
        {{ 'All rights reserved.' | translate }}
    </div>
</cwc-sidenav>